export default [
    {
        size: {
            height: 60,
            width: 400
        }, 
        position: {
            x: 0,
            y: 180
        }
    },
    {
        size: {
            height: 80,
            width: 30
        }, 
        position: {
            x: 210,
            y: 160
        }
    },
    {
        size: {
            height: 70,
            width: 30
        }, 
        position: {
            x: 320,
            y: 170
        }
    },
    //Ground blocks start here:
    {
        size: {
            height: 40,
            width: 30
        }, 
        position: {
            x: 160,
            y: 0
        }
    },
    {
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 240,
            y: 0
        }
    },
    {
        size: {
            height: 60,
            width: 60
        }, 
        position: {
            x: 360,
            y: 0
        }
    },
    {
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 560,
            y: 0
        }
    }
]


/** WEBPACK FOOTER **
 ** ./src/data/level4.js
 **/